import { Controller } from 'react-hook-form'
import { formatPhoneNumber } from '@/utils/formatters'

const patternRule = {
  pattern: {
    value: /^(\+33|0)[1-9](\d{2}){4}$/,
    message: "Veuillez entrer un numéro de téléphone valide."
  }
}

export default ({
  name = 'telephone',
  control,
  label = "Téléphone",
  defaultValue = '',
  disabled = false,
  rules,
  validator = {},
  className = '',
}) => {
  const mergedRules = rules ? {...patternRule, ...rules } : patternRule

  return <Controller
    name={name}
    control={control}
    rules={mergedRules}
    defaultValue={defaultValue}
    render={({ field }) => (
      <div className={`${className}`}>
        <label className={`input w-full mb-4 ${validator.hasError ? 'validator' : ''}`}
          {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
        >
          <span className="label">{label}</span>
          <input
            type="text"
            {...field}
            value={formatPhoneNumber(field.value || '')}
            onChange={(e) => {
              // Récupérer la valeur brute (sans formatage)
              const rawValue = e.target.value.replace(/\s/g, '')
              // Mettre à jour la valeur dans le formulaire (sans espaces)
              field.onChange(rawValue)
            }}
            disabled={disabled}
          />
        </label>
        {validator.getErrorMessage && (
          <div className="validator-hint hidden empty:py-[0.6rem]">
            {validator.getErrorMessage(name)}
          </div>
        )}
      </div>
    )}
  />
}